import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import MaterialRequestActual from './components/MaterialPrice/MaterialActual';
import MaterialRequestMax from './components/MaterialPrice/MaterialMax';
import MaterialRequest from './components/MaterialPrice/Materila';
import Dynamics from './components/MaterialPrice/Dynamics';
import DynamicsPe from './components/MaterialPrice/DynamicsPe';
import './styles/MaterialPage.css';

const MaterialEmbed: React.FC = () => {
  const [materialType, setMaterialType] = useState<'pe' | 'ppr' | 'pvh'>('pe');
  const [searchParams] = useSearchParams();
  const params = useParams<{ type?: string }>();
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const raw = (params.type || searchParams.get('type') || '').toLowerCase();
    const typeParam = raw as 'pe' | 'ppr' | 'pvh' | '';
    if (typeParam === 'pe' || typeParam === 'ppr' || typeParam === 'pvh') {
      setMaterialType(typeParam as 'pe' | 'ppr' | 'pvh');
    }
  }, [params, searchParams]);

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    function preventNav(e: Event) {
      e.preventDefault();
      e.stopPropagation();
    }
    const anchors = Array.from(root.querySelectorAll('a'));
    anchors.forEach(a => a.addEventListener('click', preventNav));
    return () => {
      anchors.forEach(a => a.removeEventListener('click', preventNav));
    };
  }, []);

  return (
    <div ref={containerRef} className="material-embed-container" style={{ padding: 16, display: 'flex', justifyContent: 'center', width: '100%' }}>
      <style>{`
        /* Hide any controls/buttons/filters/pagination within embedded view */
        .material-embed-container .navigation_material,
        .material-embed-container .material-page-header,
        .material-embed-container .download-button,
        .material-embed-container .export-btn { display: none !important; }
        /* Disable navigation out */
        .material-embed-container a { pointer-events: none; cursor: default; text-decoration: none; color: inherit; }
        /* Full width blocks in embed */
        .material-embed-container .material-actual-container,
        .material-embed-container .material-container,
        .material-embed-container .material-actual-table-container,
        .material-embed-container .material-table-container,
        .material-embed-container .chart-container.line-chart-container { width: 100% !important; max-width: 100% !important; }
      `}</style>
      <div className="material-embed-inner" style={{ width: '100%', maxWidth: '100%' }}>
        <div className="material-type-tabs" style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            className={`material-type-tab ${materialType === 'pe' ? 'active' : ''}`}
            onClick={() => { setMaterialType('pe'); try { navigate('/embed/material/pe', { replace: true }); } catch {} }}
          >Полиэтилен</button>
          <button
            className={`material-type-tab ${materialType === 'ppr' ? 'active' : ''}`}
            onClick={() => { setMaterialType('ppr'); try { navigate('/embed/material/ppr', { replace: true }); } catch {} }}
          >Полипропилен</button>
          <button
            className={`material-type-tab ${materialType === 'pvh' ? 'active' : ''}`}
            onClick={() => { setMaterialType('pvh'); try { navigate('/embed/material/pvh', { replace: true }); } catch {} }}
          >Поливинилхлорид</button>
        </div>
        <div className="material-content-area">
        <MaterialRequestActual materialType={materialType} />
        <MaterialRequestMax materialType={materialType} />
        {materialType === 'pe' ? <DynamicsPe /> : <Dynamics materialType={materialType} />}
        <MaterialRequest materialType={materialType} />
        </div>
      </div>
    </div>
  );
};

export default MaterialEmbed;


